module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_logo_wall.11f5bded.png";